export default __webpack_public_path__ + "static/leased_term_icon-8421f2442ca2a2c77d09779dca0aaa0d.svg";